'use strict';

function orientationTimeout(frames) {
  return new window.Promise(resolve => {
    const go = (i, windowHeight) => {
      window.innerHeight !== windowHeight || i >= frames
        ? resolve()
        : window.requestAnimationFrame(() => go(i + 1, windowHeight));
    };
    go(0, window.innerHeight);
  });
}

module.exports = orientationTimeout;
